import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { StorymapTheme } from '../../../api/queries';
import { useSendCommand } from '@/_core/cqrs/use';
import { ChangeStorymapTheme } from '../../../api/commands';
import { CardColor } from '@/api/workspaceSettings/queries';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeTheme extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeTheme';

    public constructor(public theme: StorymapTheme) {
        super(ChangeTheme.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeTheme): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new ChangeStorymapTheme(state.id, action.theme),
    });
};

const reducer = (state: StorymapState, action: ChangeTheme): void => {
    state.theme = action.theme;

    if (state.theme === StorymapTheme.Classic) {
        state.activityColor = CardColor.Blue;
        state.taskColor = CardColor.Yellow;
        state.subtaskColor = CardColor.White;
    }
};

//@ts-ignore
registerMiddleware(ChangeTheme.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeTheme.ACTION_TYPE, reducer);
